// Utilidad para añadir la clase 'android' al body si la plataforma es Android
import { isPlatform } from '@ionic/react';

export function setAndroidBodyClass() {
  // se añade cuando es móvil y no tablet tanto ios como android,
  // para evitar problemas con safe area en tablets
  if (isPlatform('mobile') && !isPlatform('tablet')) {
    document.body.classList.add('mobile');
  }
  if (!isPlatform('mobile') || isPlatform('tablet')) {
    document.body.classList.remove('mobile');
  }
  // solo taablets no móviles
  if (isPlatform('tablet') && !isPlatform('mobile')) {
    document.body.classList.add('tablet');
  }
  if (!isPlatform('tablet') || isPlatform('mobile')) {
    document.body.classList.remove('tablet');
  }
  // tablet y móviles
  if (isPlatform('mobile') || isPlatform('tablet')) {
    document.body.classList.add('mobile-tablet');
  }
  if (!isPlatform('mobile') && !isPlatform('tablet')) {
    document.body.classList.remove('mobile-tablet');
  }
  if (isPlatform('android')) {
    document.body.classList.add('android');
  } else {
    document.body.classList.remove('android');
  }
  // Firefox en Android tiene un bug: al colapsar/expandir la barra de navegación
  // (si está arriba) deja un gap-bottom porque no recalcula bien el viewport.
  // Marcamos el body para aplicar el fix con 100dvh. Ver GlobalStyles.scss.
  const ua = navigator.userAgent.toLowerCase();
  const isFirefoxAndroid = ua.includes('firefox') && ua.includes('android');
  if (isFirefoxAndroid) {
    document.body.classList.add('firefox-android');
  } else {
    document.body.classList.remove('firefox-android');
  }
}
